import axios from 'axios';
import apiroutes from '@/API/ApiRoutes';


const state = {
  donationInfo: {
    donation: {},
    edit: true
  }
};

const getters = {};

const actions = {

  GetMyDonationList({commit}, payload) {

    return new Promise((resolve, reject) => {
      let tok = '';
      let auth = JSON.parse(localStorage.getItem('auth-response'));
      if (auth) {
        tok = 'Bearer ' + auth.access_token;
      } else {
        tok = '';
      }

      let authheader = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        Authorization: tok
      };
      let id = JSON.parse(localStorage.getItem('user-response'));
      axios.get(apiroutes.routes.blood_donors + id.data.donor_profile.id + apiroutes.routes.blood_donations, {headers: authheader})

        .then((response) => {
          console.log('donation', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
};

const mutations = {
  setDonation(state, payload) {
    Object.assign(state.donationInfo.donation, payload);
    state.donationInfo.edit =true;

  },
  clearInfoDonation(state, payload) {
    state.donationInfo.donation = {};
    state.donationInfo.edit =false;

  }

};

export default {
  state,
  getters,
  actions,
  mutations
};
